import { ReactElement } from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

export const TicketsTableHead = (): ReactElement => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>ID</TableCell>
        <TableCell>TICKET</TableCell>
        <TableCell>PRICE</TableCell>
        <TableCell>SEATS</TableCell>
        <TableCell>SCHEDULE</TableCell>
        <TableCell>STATUS</TableCell>
        <TableCell>ACTIONS</TableCell>
      </TableRow>
    </TableHead>
  );
};
